import styled, { css } from "styled-components";
import MenuIconButton from "./MenuIconButton";
import Navigation from "./Navigation";
import { useRetractableMenu } from "../context/RetractableMenuContext";
import Footer from "./Footer";

const StyledSidebar = styled.aside`
  padding: 1rem 1.2rem;

  grid-row: 1/ -1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 18rem;
  transition: width 0.3s ease, align-items 0.3s ease;

  background-color: var(--color-primary);
  align-items: flex-start;

  z-index: 1;

  ${(props) =>
    !props.isExpanded &&
    css`
      width: 5rem;
    `}

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 768px) {
    display: flex;
    position: absolute;
    top: 0;
    left: -100%;
    height: 100%;
    width: 250px;
    background-color: var(--color-primary);
    transition: left 0.3s ease-in-out;

    ${(props) =>
      props.isExpanded &&
      css`
        left: 0;
      `}
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  width: 100%;
  align-items: flex-start;
`;

function Sidebar() {
  const { isExpanded } = useRetractableMenu();

  return (
    <StyledSidebar isExpanded={isExpanded}>
      <Nav>
        <MenuIconButton />
        <Navigation />
      </Nav>

      <Footer />
    </StyledSidebar>
  );
}

export default Sidebar;
